import { Button, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import PaymentTable from './Components/PaymentStatus/PaymentRequestTable'
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';


const PaymentRequest = () => {
  const [Filter, setFilter] = React.useState({
    name:'',
    bank:'',
    mobile_number:'',
    mode_of_paymnet:'',
    payment_status:''
  });

  const handleChange = (name,value) => {
    console.log(name,value);
    
    if(name==='name'&&/^[A-Za-z]*$/.test(value)){
      setFilter({...Filter, [name]:value});
    }
    else if(name==='bank'&&/^[A-Za-z]*$/.test(value)){
      setFilter({...Filter, [name]:value});
    }
    else if(name==='mobile_number'&&/^\d*$/.test(value)&&value.length<=10){
      setFilter({...Filter, [name]:value});
    }
    else if(name==='mode_of_paymnet'&&/^[A-Za-z]*$/.test(value)){
      setFilter({...Filter, [name]:value});
    }
    else if(name==='payment_status'&&/^[A-Za-z]*$/.test(value)){
      setFilter({...Filter, [name]:value});
    }
    console.log(name,value);
    
    if(name==='name'&&/^[A-Za-z]*$/.test(value)){
      setFilter({...Filter, [name]:value});
    }
    else if(name==='bank'&&/^[A-Za-z]*$/.test(value)){
      setFilter({...Filter, [name]:value});
    }
    else if(name==='mobile_number'&&/^\d*$/.test(value)&&value.length<=10){
      setFilter({...Filter, [name]:value});
    }
    else if(name==='mode_of_paymnet'&&/^[A-Za-z]*$/.test(value)){
      setFilter({...Filter, [name]:value});
    }
    else if(name==='payment_status'&&/^[A-Za-z]*$/.test(value)){
      setFilter({...Filter, [name]:value});
    }
  };

  const handleClearFilter=()=>{
    setFilter({
      name:'',
    bank:'',
    mobile_number:'',
    mode_of_paymnet:'',
    payment_status:''
    })
  }

  return (
    <Grid container>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
        <MainCard>
          <Grid container spacing={2} alignItems='center'>
            <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
              <Typography variant='h5' marginBottom={1} sx={{ color: "#20415C" }}>Agent name</Typography>
              <TextField
                size='small'
                fullWidth
                value={Filter.name}
                onChange={(e)=>handleChange('name',e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: '2px solid #A9A9A980 50%', // change border color
                    borderRadius: '8px',
                  },
                  '& fieldset': {
                    borderColor: '#A9A9A980',
                    borderRadius: '8px'// default border color
                  },
                }
                }
              />

            </Grid>
            <Grid item  xl={3} lg={3} md={4} sm={6} xs={6}>
              <Typography variant='h5' marginBottom={1} sx={{ color: "#20415C" }}>Mobile Number</Typography>
              <TextField
              fullWidth
                size='small'
                value={Filter.mobile_number}
                onChange={(e)=>handleChange('mobile_number',e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: '2px solid #A9A9A980 50%', // change border color
                    borderRadius: '8px',
                  },
                  '& fieldset': {
                    borderColor: '#A9A9A980',
                    borderRadius: '8px'// default border color
                  },
                }
                }
              />

            </Grid>
            {/* <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
              <TextField
                label="Bank name"
                fullWidth
                value={Filter.bank}
                onChange={(e)=>handleChange('bank',e.target.value)}
              />
            </Grid>

            <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Payment type</InputLabel>
                <Select
                  labelid="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Filter.mode_of_paymnet}
                  label="Payment type"
                  onChange={(e)=>handleChange('mode_of_paymnet',e.target.value)}
                >
                  <MenuItem value={'full'}>Full payment</MenuItem>
                  <MenuItem value={'part'}>Part payment</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Payment Status</InputLabel>
                <Select
                  labelid="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Filter.payment_status}
                  label="Payment Status"
                  onChange={(e)=>handleChange('payment_status',e.target.value)}
                >
                  <MenuItem value={'pending'}>Pending</MenuItem>
                  <MenuItem value={'completed'}>Completed</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}


            <Grid item md={2} xs={12} mt={3}>
              <Button 
                fullWidth 
                variant='contained' 
                color='secondary' 
                onClick={()=>handleClearFilter()}
                sx={{
                  backgroundColor: "#592375",
                  color: "#FFFFFF",
                  borderRadius: "6px",
                  "&:hover": {
                    backgroundColor: "#592375",
                  },
                }}
                >clear</Button>
            </Grid>
          </Grid>
        </MainCard>
        

      </Grid>
      <Grid item xl={12} lg={12} md={12}  sm={12} xs={12}>  
      <MainCard  sx={{marginTop:'20px',width:'100%',height:"100%",overflow:'scroll'}}>
          <PaymentTable filter={Filter} />
        </MainCard>
      </Grid>
    </Grid>
  )
}

export default PaymentRequest
